
import { combineReducers } from "@reduxjs/toolkit";
import internalSalesListReducer from "./internal-sales-list.slice";
import internalFilterSalesReducer from "./internal-filter-sales.slice";

const reducer = combineReducers({
  list: internalSalesListReducer,
  filters: internalFilterSalesReducer,
});

export default reducer;
